import { render } from "./ExampleDataVisualizationSource.vue?vue&type=template&id=4975067b"
import script from "./ExampleDataVisualizationSource.vue?vue&type=script&lang=js"
export * from "./ExampleDataVisualizationSource.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__